/**
 * Custom hook for Meta Pixel (Facebook Pixel) tracking
 */

import { useCallback } from 'react';

// Extend the Window interface to include fbq
declare global {
  interface Window {
    fbq: (action: string, event: string, data?: any) => void;
  }
}

export const useMetaPixel = () => {
  const trackEvent = useCallback((eventName: string, data?: any) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', eventName, data);
    }
  }, []);

  const trackPurchase = useCallback(
    (value: number, currency: string = 'USD', additionalData?: any) => {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'Purchase', {
          value,
          currency,
          ...additionalData,
        });
      }
    },
    []
  );

  const trackAddToCart = useCallback(
    (value: number, currency: string = 'USD', contentIds?: string[], additionalData?: any) => {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart', {
          value,
          currency,
          content_ids: contentIds,
          ...additionalData,
        });
      }
    },
    []
  );

  const trackInitiateCheckout = useCallback(
    (value: number, currency: string = 'USD', additionalData?: any) => {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
          value,
          currency,
          ...additionalData,
        });
      }
    },
    []
  );

  const trackLead = useCallback((additionalData?: any) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Lead', additionalData);
    }
  }, []);

  const trackCompleteRegistration = useCallback((additionalData?: any) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'CompleteRegistration', additionalData);
    }
  }, []);

  return {
    trackEvent,
    trackPurchase,
    trackAddToCart,
    trackInitiateCheckout,
    trackLead,
    trackCompleteRegistration,
  };
};
